import React from 'react'
import { Link } from 'gatsby'

import Layout from '../components/layout'
import Billboard from '../components/Billboard'
import FeaturedArticles from '../components/pages/index/FeaturedArticles'

import BestPractices from '../components/pages/aws-well-architected-reviews/BestPractices'
import Pillars from '../components/pages/aws-well-architected-reviews/Pillars'
import ReviewProcess from '../components/pages/aws-well-architected-reviews/ReviewProcess'
import Seo from '../components/seo'

const AwsWellArchitectedReviewsPage = () => (
  <Layout>
    <Seo
      title="AWS Well-Architected Framework Reviews"
      description="We make sure you’re following AWS best practices with Well-Architected Framework reviews to catch and mitigate any issues."
    />

    <Billboard>
      <div className="Billboard__top">
        <h1 className="Billboard__title">
          AWS Well-Architected Framework Reviews
        </h1>
        <div className="Billboard__lead">
          Ensure your cloud infrastructure is secure and follows AWS best
          practices.
        </div>

        <div className="Billboard__cta">
          <Link to="/contact" className="btn btn-orange btn-lg">
            Schedule Now
          </Link>
        </div>
      </div>
    </Billboard>

    <BestPractices />
    <Pillars />
    <ReviewProcess />

    <FeaturedArticles />
  </Layout>
)

export default AwsWellArchitectedReviewsPage
